var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.companies
    ? _c(
        "section",
        { staticClass: "w-full" },
        [
          _c("PostingFilters", {
            attrs: {
              currentUserId: _vm.currentUser.id,
              currentUserRole: _vm.currentUser.role,
              displayCompaniesFilter: !_vm.isMarketplace,
              filters: _vm.postingFilters,
            },
            on: {
              filtersChanged: _vm.updateFilters,
              resetFilters: _vm.resetFilters,
            },
          }),
          _c("ActionPanel", {
            staticClass: "mb-4 font-medium",
            attrs: { total: _vm.paginationConfig.total },
          }),
          _c(
            "LoadingOverlay",
            {
              attrs: { hasData: !!_vm.postings, loading: _vm.$apollo.loading },
            },
            [
              _vm.empty
                ? _c("EmptyListPlaceholder", {
                    attrs: { title: _vm.emptyListMessage },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "image",
                          fn: function () {
                            return [_c("EmptyListImagePosting")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      446318279
                    ),
                  })
                : [
                    _c(
                      "div",
                      { staticClass: "flex flex-wrap gap-4 topScroll mb-4" },
                      _vm._l(_vm.postings, function (posting) {
                        return _c("PostingCard", {
                          key: posting.id,
                          attrs: {
                            posting: posting,
                            currentUserId: _vm.currentUser.id,
                            isMarketplace: _vm.isMarketplace,
                          },
                        })
                      }),
                      1
                    ),
                    _c("CardPagination", {
                      attrs: { config: _vm.paginationConfig },
                      on: {
                        "update:config": function ($event) {
                          _vm.paginationConfig = $event
                        },
                      },
                    }),
                  ],
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }